<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}
</style>
<style lang="scss" scoped>
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg_2.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 0px 10px 10px 10px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          {{ $t('shujuhuizong') }}
        </div>
      </div>

      <div style="display: flex;justify-content: space-between;padding: 10px 0;" :style="{ height: chartHeight + 'px' }">
        <div v-if="cockpitData.sum" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;align-items: center;" :style="{ height: chartHeight - 20 + 'px' }">
          <div>
            <img style="width: 140px;height: auto;" :src="require('../../../../../../../assets/img/web/energy/energy' + 1 + '.png')" />
          </div>
          <div style="text-align: center;">
            <p style="font-size: 14px;color: #999999;">{{ $t('zuorizongyongdianliang') }}</p>
            <p style="font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
              {{ cockpitData.sum.yesterdayTotalEle.toFixed(2) }}<span style="font-size: 14px;color: #999999;">{{ $t('kwh') }}</span>
            </p>
          </div>
          <div style="text-align: center;">
            <p style="font-size: 14px;color: #999999;">{{ $t('jiaoguoqusanshitianrijunyongdian') }}</p>
            <div style="display: flex;align-items: center;justify-content: center;">
              <img v-if="cockpitData.sum.thanThirtyDayAverageEle >= 0" style="width: 52px;height: auto;" src="../../../../../../../assets/img/web/energy/up.png" />
              <img v-if="cockpitData.sum.thanThirtyDayAverageEle < 0" style="width: 52px;height: auto;" src="../../../../../../../assets/img/web/energy/down.png" />
              <p style="margin-left: 10px;font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
                {{ cockpitData.sum.thanThirtyDayAverageEle.toFixed(2) }}%
              </p>
            </div>
          </div>
        </div>
        <div v-if="cockpitData.sum" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;align-items: center;" :style="{ height: chartHeight - 20 + 'px' }">
          <div>
            <img style="width: 140px;height: auto;" :src="require('../../../../../../../assets/img/web/energy/energy' + 2 + '.png')" />
          </div>
          <div style="text-align: center;">
            <p style="font-size: 14px;color: #999999;">{{ $t('dangyueyongdianzongliang') }}</p>
            <p style="font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
              {{ cockpitData.sum.theMonthTotalEle.toFixed(2) }}<span style="font-size: 14px;color: #999999;">{{ $t('kwh') }}</span>
            </p>
          </div>
          <div style="text-align: center;">
            <p style="font-size: 14px;color: #999999;">{{ $t('jiaoshangyuetongqiyongdian') }}</p>
            <div style="display: flex;align-items: center;justify-content: center;">
              <img v-if="cockpitData.sum.thanLastMonthSameDateEle >= 0" style="width: 52px;height: auto;" src="../../../../../../../assets/img/web/energy/up.png" />
              <img v-if="cockpitData.sum.thanLastMonthSameDateEle < 0" style="width: 52px;height: auto;" src="../../../../../../../assets/img/web/energy/down.png" />
              <p style="margin-left: 10px;font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
                {{ cockpitData.sum.thanLastMonthSameDateEle.toFixed(2) }}%
              </p>
            </div>
          </div>
        </div>
        <div v-if="cockpitData.sum" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;align-items: center;" :style="{ height: chartHeight - 20 + 'px' }">
          <div>
            <img style="width: 140px;height: auto;" :src="require('../../../../../../../assets/img/web/energy/energy' + 3 + '.png')" />
          </div>
          <div style="text-align: center;">
            <p style="font-size: 14px;color: #999999;">{{ $t('jinnianzongyongdianliang') }}</p>
            <p style="font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
              {{ cockpitData.sum.theYearTotalEle.toFixed(2) }}<span style="font-size: 14px;color: #999999;">{{ $t('kwh') }}</span>
            </p>
          </div>
          <div style="text-align: center;">
            <p style="font-size: 14px;color: #999999;">{{ $t('jiaoquniantongqiyongdian') }}</p>
            <div style="display: flex;align-items: center;justify-content: center;">
              <img v-if="cockpitData.sum.thanLastYearSameDateEle >= 0" style="width: 52px;height: auto;" src="../../../../../../../assets/img/web/energy/up.png" />
              <img v-if="cockpitData.sum.thanLastYearSameDateEle < 0" style="width: 52px;height: auto;" src="../../../../../../../assets/img/web/energy/down.png" />

              <p style="margin-left: 10px;font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
                {{ cockpitData.sum.thanLastYearSameDateEle.toFixed(2) }}%
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_energy_sum',
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      timer: null,
      chartHeight: 0
    };
  },
  created() { },

  watch: {
    cockpitData(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.makeChart();
    }
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    makeChart() { },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 30;
      }, 800);
    }
  }
};
</script>
